/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Parsing_AiInputs */

const en_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parsing resume with AI...`)
};

const de_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf wird mit KI analysiert...`)
};

const fr_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du CV par IA...`)
};

const es_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando currículum con IA...`)
};

const it_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi del curriculum con AI...`)
};

const nl_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV verwerken met AI...`)
};

const pl_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza CV z AI...`)
};

const fi_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jäsennetään ansioluetteloa tekoälyllä...`)
};

const da_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyserer CV med AI...`)
};

const sv_resumes_parsing_ai = /** @type {(inputs: Resumes_Parsing_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolkar CV med AI...`)
};

/**
* | output |
* | --- |
* | "Parsing resume with AI..." |
*
* @param {Resumes_Parsing_AiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_parsing_ai = /** @type {((inputs?: Resumes_Parsing_AiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Parsing_AiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_parsing_ai(inputs)
	if (locale === "fr") return fr_resumes_parsing_ai(inputs)
	if (locale === "es") return es_resumes_parsing_ai(inputs)
	if (locale === "it") return it_resumes_parsing_ai(inputs)
	if (locale === "nl") return nl_resumes_parsing_ai(inputs)
	if (locale === "pl") return pl_resumes_parsing_ai(inputs)
	if (locale === "fi") return fi_resumes_parsing_ai(inputs)
	if (locale === "da") return da_resumes_parsing_ai(inputs)
	if (locale === "sv") return sv_resumes_parsing_ai(inputs)
	return en_resumes_parsing_ai(inputs)
});